/** Build the Phoenix WebSocket URL from REACT_APP_API_BASE_URL. */

// Region picker override (services/regionService.js): when set, every socket
// (re)construction uses the chosen regional endpoint instead of the API base.
let overrideUrl = null;

export function setPhoenixSocketOverride(url) {
  overrideUrl = url || null;
}

export function getPhoenixSocketUrl() {
  if (overrideUrl) return overrideUrl;
  const base = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/api/v1';
  return base
    .replace(/^http:/, 'ws:')
    .replace(/^https:/, 'wss:')
    .replace(/\/api(\/v1)?\/?$/, '/socket');
}
